import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { EnvAccessType } from "../utils/constants";

let firebaseConfig = {};

switch (process.env.React_App_access_type) {
  case EnvAccessType.PROD:
    firebaseConfig = {
      apiKey: process.env.React_App_PROD_Api_Key,
      authDomain: process.env.React_App_PROD_Auth_Domain,
      projectId: process.env.React_App_PROD_Project_Id,
      storageBucket: process.env.React_App_PROD_Storage_Bucket,
      messagingSenderId: process.env.React_App_PROD_Messaging_Sender_Id,
      appId: process.env.React_App_PROD_App_Id,
    };
    break;

  case EnvAccessType.DEV:
    firebaseConfig = {
      apiKey: process.env.React_App_DEV_Api_Key,
      authDomain: process.env.React_App_DEV_Auth_Domain,
      projectId: process.env.React_App_DEV_Project_Id,
      storageBucket: process.env.React_App_DEV_Storage_Bucket,
      messagingSenderId: process.env.React_App_DEV_Messaging_Sender_Id,
      appId: process.env.React_App_DEV_App_Id,
      measurementId: process.env.React_App_DEV_Measurement_Id,
    };
    break;
}

// Aracdis
// const firebaseConfig = {
//   apiKey: "AIzaSyC_w0IE0MJNZwsnJLaITPgEtayJFpP_eYE",
//   authDomain: "arcadis-89282.firebaseapp.com",
//   projectId: "arcadis-89282",
//   storageBucket: "arcadis-89282.firebasestorage.app",
//   messagingSenderId: "604166867257",
//   appId: "1:604166867257:web:440c462dc55dbe4e7ac0e8",
//   measurementId: "G-0T6TZ9CFTD"
// };

// my personal
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyBXPLL49Bih6pK-z5BqBtW_pvAcnh7slpU",
//   authDomain: "eduate2.firebaseapp.com",
//   projectId: "eduate2",
//   storageBucket: "eduate2.appspot.com",
//   messagingSenderId: "735882090232",
//   appId: "1:735882090232:web:01b4872ff4e1757c7e0d0d",
//   measurementId: "G-1FPBB30H9C",
// };
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db };
export { storage as default };
